// extracted by mini-css-extract-plugin
export default {"about_container":"about_about_container__roqtD"};